import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Categories from './components/Categories';
import Products from './components/Products';
import './App.css';

function App() { //fmfcs
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [weeklyBasket, setWeeklyBasket] = useState([]);
  const [basketDate, setBasketDate] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [notification, setNotification] = useState(null);

  // API base URL - configured via environment variable
  const API_BASE = process.env.REACT_APP_API_BASE_ENDPOINT;

  useEffect(() => {
    fetchData();
  }, []);

  // Listen for basket item removal events
  useEffect(() => {
    const handleBasketItemRemoved = (event) => {
      const { productId, updatedBasket } = event.detail;
      setWeeklyBasket(updatedBasket);
    };

    window.addEventListener('basketItemRemoved', handleBasketItemRemoved);

    // Cleanup event listener
    return () => {
      window.removeEventListener('basketItemRemoved', handleBasketItemRemoved);
    };
  }, []);

  // Listen for adding products to basket events
  useEffect(() => {
    const handleAddProductToBasket = (event) => {
      const { product, quantity } = event.detail;
      
      // Show notification
      setNotification(`Adicionado ao carrinho: ${quantity} ${product.name}`);
      
      // Auto-hide notification after 3 seconds
      setTimeout(() => {
        setNotification(null);
      }, 3000);
      
      setWeeklyBasket(prevBasket => {
        // Check if product already exists in basket
        const existingProductIndex = prevBasket.findIndex(item => item.id === product.id);
        
        if (existingProductIndex >= 0) {
          // Product exists, update quantity
          const updatedBasket = [...prevBasket];
          const currentQuantity = updatedBasket[existingProductIndex].minAmount || 0;
          updatedBasket[existingProductIndex] = {
            ...updatedBasket[existingProductIndex],
            minAmount: currentQuantity + quantity
          };
          return updatedBasket;
        } else {
          // Product doesn't exist, add new item
          const newBasketItem = {
            ...product,
            minAmount: quantity
          };
          return [...prevBasket, newBasketItem];
        }
      });
    };

    window.addEventListener('addProductToBasket', handleAddProductToBasket);

    // Cleanup event listener
    return () => {
      window.removeEventListener('addProductToBasket', handleAddProductToBasket);
    };
  }, []);

  // Filter products by selected category
  const filteredProducts = selectedCategory 
    ? products.filter(product => {
        // Convert both to numbers for reliable comparison
        const productCategoryId = Number(product.categoryId);
        const selectedCatId = Number(selectedCategory);
        
        return productCategoryId === selectedCatId;
      })
    : products;

  // Handle category selection
  const handleCategorySelect = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Fetch products, categories, and weekly basket
      const [productsResponse, categoriesResponse, weeklyBasketResponse] = await Promise.all([
        fetch(`${API_BASE}/products`),
        fetch(`${API_BASE}/categories`),
        fetch(`${API_BASE}/weekly-basket`)
      ]);
      
      if (!productsResponse.ok) {
        throw new Error(`Products API failed: ${productsResponse.status}`);
      }
      if (!categoriesResponse.ok) {
        throw new Error(`Categories API failed: ${categoriesResponse.status}`);
      }
      if (!weeklyBasketResponse.ok) {
        throw new Error(`Weekly basket API failed: ${weeklyBasketResponse.status}`);
      }
      
      const productsData = await productsResponse.json();
      const categoriesData = await categoriesResponse.json();
      const weeklyBasketData = await weeklyBasketResponse.json();
      
      // Handle API response wrapper: { status: "OK", data: [...] }
      if (productsData.status === 'ERROR') {
        throw new Error(`Products API error: ${productsData.message}`);
      }
      if (categoriesData.status === 'ERROR') {
        throw new Error(`Categories API error: ${categoriesData.message}`);
      }
      if (weeklyBasketData.status === 'ERROR') {
        throw new Error(`Weekly basket API error: ${weeklyBasketData.message}`);
      }
      
      setProducts(productsData.data || productsData);
      setCategories(categoriesData.data || categoriesData);
      setWeeklyBasket(weeklyBasketData.data || weeklyBasketData);
      setBasketDate(weeklyBasketData.basketDate);
      
    } catch (error) {
      console.error('Error fetching data:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">A carregar os produtos...</div>;
  }

  if (error) {
    return (
      <div className="error">
        <h2>Erro ao carregar produtos</h2>
        <p>{error}</p>
        <button onClick={fetchData}>Tentar novamente</button>
      </div>
    );
  }

  return (
    <div className="App">
      {/* Notification Bar */}
      {notification && (
        <div className="notification-bar">
          {notification}
        </div>
      )}
      
      <div className="cbn-body">
        <Header />
        <div className="id-atf-body shop" id="Body">
          <div className="cbn-store">
            <div className="id-products" id="Products2">
              {/* Categories Filter */}
              <Categories 
                categories={categories}
                selectedCategory={selectedCategory}
                onCategorySelect={handleCategorySelect}
              />
              
              {/* Products List */}
              <Products products={filteredProducts} weeklyBasket={weeklyBasket} basketDate={basketDate} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;

